/**
 * หน้าจอ Customer Master (P2-4a) — รายการลูกค้า ค้นหา กรองสถานะ สร้าง และแก้ไข
 *
 * ปิดทั้งสี่เส้นทางของ contract ที่ `WO-P2-M4-001` เปิดไว้ (D-089):
 * `GET /v1/customers`, `POST /v1/customers`, `GET /v1/customers/{customer_id}` และ
 * `PATCH /v1/customers/{customer_id}`
 *
 * **หน้านี้เป็นฝาแฝดของ `suppliers/SupplierScreen` โดยตั้งใจ** — contract เองเขียนไว้
 * ว่า Customer Master "มิเรอร์ Supplier Master (D-083) แบบตั้งใจ" ทั้งสองคือทะเบียน
 * คู่ค้าระดับองค์กรที่มี business code แก้ไม่ได้ สามสถานะ และไม่มี DELETE สิ่งที่
 * ต่างกันจึงมีเพียงสิ่งที่ D-089 ขอ: **ตัวกรองสถานะ** ซึ่งยิงเป็น `?status=` ไปที่
 * เซิร์ฟเวอร์จริง (ไม่ใช่กรองฝั่งเบราว์เซอร์) เพราะ contract รับพารามิเตอร์นั้น
 *
 * สองข้อที่หน้าจอนี้ต้องพูดออกมาให้ดัง ไม่ใช่ซ่อนไว้:
 *
 * 1. **`customer_code` แก้ไม่ได้** (D-089) กล่องแก้ไขจึงแสดงรหัสเป็นข้อความอ่าน
 *    อย่างเดียว ไม่ใช่ช่องกรอกที่ disabled ไว้เฉย ๆ — ใบสั่งขาย lot และการส่งของที่
 *    อ้างรหัสนั้นอยู่ต้องตามสอบกลับมาถึงลูกค้ารายนี้ได้เสมอ การกันซ้ำ Customer PO
 *    ด้วย `UNIQUE(customer_id, customer_po_number)` ก็พังทันทีถ้ารหัสขยับได้ และ
 *    คำขอที่มีคีย์นั้นติดไปด้วยจะถูกตอบ `400 CUSTOMER_CODE_IS_IMMUTABLE`
 * 2. **ไม่มีการลบลูกค้า** เลิกค้าขายคือการเปลี่ยนสถานะเป็น `INACTIVE` ซึ่งเป็นสิ่งที่
 *    กล่องแก้ไขทำ ไม่ใช่ปุ่มที่หายไปเพราะยังไม่ได้ทำ
 *
 * D-123 เพิ่มสามอย่างให้ตารางนี้ และทั้งสามอย่างเป็นงานของ **เบราว์เซอร์** ไม่ใช่
 * ของเซิร์ฟเวอร์:
 *
 * - **ทะเบียนถูกโหลดครบทุกหน้า** (`fetchAllCustomers`) ก่อนเรียงหรือแบ่งหน้า — การ
 *   เรียงเฉพาะหน้าแรกที่เซิร์ฟเวอร์ส่งมาไม่ใช่การเรียง มันคือการสลับลำดับของกลุ่ม
 *   ตัวอย่าง และผู้ใช้ที่กด "ชื่อลูกค้า" จะเชื่อว่าเขาเห็นรายแรกตามตัวอักษรทั้งที่ไม่ใช่
 * - **เรียงได้สามคอลัมน์** ผ่าน `SortableHeader` ซึ่งเป็น component กลางที่ไม่รู้จัก
 *   ลูกค้าเลย — ตัวที่รู้ว่าคอลัมน์ไหนเทียบด้วยค่าอะไรคือ `sortText` ในไฟล์นี้
 * - **20 แถวต่อหน้า** พร้อมก่อนหน้า/ถัดไป และ `sort`/`dir`/`page` อยู่ใน URL เพื่อให้
 *   refresh และลิงก์ที่ส่งต่อให้ผลเดิม
 *
 * และ `?view=detail&customer=<id>` เปิด `CustomerDetailView` ซึ่งเป็น **หน้าจอย่อย
 * ไม่ใช่ modal** — ที่อยู่หลายบรรทัดกับผู้ติดต่อสามรายไม่พอดีกับกล่องที่ลอยทับตาราง
 *
 * **ไม่มีตัวเลือกโรงงานที่ไหนในไฟล์นี้เลย** ทะเบียนลูกค้าเป็นข้อมูลระดับองค์กรและ
 * resource ไม่มี `plant_code`/`plant_id` ทั้งขาไปและขากลับ (D-089) — ตัวควบคุมโรงงาน
 * บนทะเบียนระดับองค์กรจะบอกผู้ใช้ผิดว่าเขากำลังตั้งค่าอะไรอยู่
 *
 * การ gate สิทธิ์เป็นแบบเดียวกับทุกหน้าจอธุรกิจ: `CUSTOMER_MASTER` + `VIEW` เป็น
 * สิทธิ์ของ **การเปิดหน้าจอนี้** (ด่านอยู่ที่ route) ส่วน `CREATE` และ `EDIT` เป็น
 * สิทธิ์ของ **ปุ่มที่เขียน** ซึ่งถูกบังคับข้างในนี้ทีละปุ่ม — และทั้งสองแยกจากกัน
 * จริง คนที่เพิ่มลูกค้าใหม่ได้ไม่จำเป็นต้องแก้ของเดิมได้ และกลับกัน
 *
 * ⚠️ ทั้งหมดนี้เป็น UX layer ไม่ใช่ด่านความปลอดภัย เซิร์ฟเวอร์เป็นผู้ตัดสินทุก
 * request เสมอ (`references/authorization-rbac.md` ข้อ 5) ที่ซ่อนปุ่มเพราะไม่อยาก
 * ให้ผู้ใช้กรอกฟอร์มแล้วโดนปฏิเสธตอนกดบันทึก
 */

import { useEffect, useState } from 'react';
import { Link, useLocation, useSearchParams } from 'react-router-dom';

import { CustomerCreateView } from './CustomerCreateView';
import { CustomerDetailView } from './CustomerDetailView';
import { CustomerEditView } from './CustomerEditView';
import { StatusBadge } from '../StatusBadge';
import { InfoHint } from '../components/InfoHint';
import { SortableHeader, type SortDirection } from '../components/SortableHeader';
import { useTrailingCrumbs } from '../desktopContext';
import { can } from '../../lib/permissions/client';
import type { PermissionsState } from '../../lib/permissions/types';
import {
  fetchAllCustomers,
  ruleFromFailure,
  type ApiErrorEnvelope,
  type CustomerFailure,
} from '../../lib/customers/client';
import {
  CUSTOMER_STATUS_DESCRIPTORS,
  customerStatusLabel,
  customerStatusTone,
  filterCustomers,
  toCustomerStatusFilter,
} from '../../lib/customers/customersView';
import {
  CUSTOMER_CODE_IS_IMMUTABLE,
  CUSTOMER_CODE_MAX_LENGTH,
  CUSTOMER_CODE_TAKEN,
  CUSTOMER_FIELD_IS_SERVER_OWNED,
  CUSTOMER_MASTER_MODULE,
  CUSTOMER_NAME_MAX_LENGTH,
  type Customer,
} from '../../lib/customers/types';

/* ------------------------------------------------- หน้าจอความล้มเหลว ----- */

type CustomerFailureContext =
  /** อ่านรายการลูกค้า */
  | 'customers'
  /** อ่านลูกค้ารายเดียวในหน้ารายละเอียด */
  | 'detail'
  /** สร้างลูกค้าใหม่ */
  | 'create'
  /** แก้ไขลูกค้ารายเดิม */
  | 'edit';

interface FailureCopy {
  readonly heading: string;
  readonly text: string;
}

/**
 * ประโยค "ไม่มีอะไรเปลี่ยน" ของแต่ละ context ที่ **เขียน** — สตริงว่างสำหรับ
 * context ที่อ่านอย่างเดียว
 *
 * ทุก write ของกลุ่มนี้เขียน `audit_log` (entity_type `Customer`) **ในธุรกรรม
 * เดียวกับการเปลี่ยนข้อมูล** ล้มจุดใดก็ไม่เหลือทั้งสองอย่าง — ประโยคนี้จึงเป็น
 * ข้อเท็จจริงของ contract ไม่ใช่คำปลอบใจ
 */
function nothingChangedText(context: CustomerFailureContext): string {
  switch (context) {
    case 'create':
      return ' ไม่มีลูกค้ารายใดถูกสร้างและไม่มีแถว audit ถูกเขียน';
    case 'edit':
      return ' ข้อมูลลูกค้ารายนี้ยังเป็นชุดเดิมทุกฟิลด์และไม่มีแถว audit ถูกเขียน';
    case 'customers':
    case 'detail':
      return '';
  }
}

function isWriteContext(context: CustomerFailureContext): boolean {
  return nothingChangedText(context) !== '';
}

/**
 * ข้อความของกฎแต่ละข้อ — คืน `null` เมื่อไม่ใช่กฎที่ contract เขียนไว้
 *
 * ⚠️ ห้ามเพิ่มรหัสที่ contract ไม่ได้ระบุลงใน `switch` นี้ — รหัสที่หน้าจอคิดขึ้นเอง
 * คือข้อความที่ไม่มีวันแสดง และเป็นคำสัญญาที่ backend ไม่เคยให้ไว้ (โดยเฉพาะ
 * `CUSTOMER_IS_BLOCKED`/`CUSTOMER_IS_INACTIVE` ซึ่งเป็นกฎของใบสั่งขายที่ P2-4b
 * ไม่ใช่ของทะเบียนนี้)
 */
function ruleCopy(rule: string | null): FailureCopy | null {
  switch (rule) {
    case CUSTOMER_CODE_TAKEN:
      return {
        heading: 'รหัสลูกค้านี้มีเจ้าของอยู่แล้ว',
        text: `เซิร์ฟเวอร์ตอบ 409 พร้อมกฎ ${CUSTOMER_CODE_TAKEN} — รหัสลูกค้าต้องไม่ซ้ำกันทั้งองค์กรและแก้ไม่ได้หลังสร้าง (D-089) ใช้รหัสอื่น หรือถ้าลูกค้าที่ตั้งใจจะเพิ่มคือรายที่ถือรหัสนี้อยู่แล้ว เขามีอยู่ในระบบแล้วและแก้ไขได้จากรายการด้านล่าง **ไม่มีลูกค้ารายใดถูกสร้างขึ้น และข้อมูลของรายที่ถือรหัสนี้ไม่ถูกทับ**`,
      };
    case CUSTOMER_CODE_IS_IMMUTABLE:
      return {
        heading: 'หน้าจอกับเซิร์ฟเวอร์ไม่ตรงกัน — รหัสลูกค้าถูกส่งไปกับคำขอแก้ไข',
        text: `เซิร์ฟเวอร์ตอบ 400 พร้อมกฎ ${CUSTOMER_CODE_IS_IMMUTABLE} — รหัสลูกค้าเป็น business key ที่ใบสั่งขาย lot และการส่งของอ้างอยู่ จึงเขียนครั้งเดียวตอนสร้างและแก้ไม่ได้อีกเลย กล่องแก้ไขนี้ไม่มีเส้นทางที่ส่งรหัสไปกับคำขอด้วยซ้ำ การที่มันไปถึงเซิร์ฟเวอร์จึงเป็นบั๊ก — แจ้งผู้ดูแลระบบ อย่าลองกดซ้ำ **ข้อมูลลูกค้ารายนี้ยังเป็นชุดเดิมทุกฟิลด์**`,
      };
    case CUSTOMER_FIELD_IS_SERVER_OWNED:
      return {
        heading: 'หน้าจอกับเซิร์ฟเวอร์ไม่ตรงกัน — ฟิลด์ของเซิร์ฟเวอร์ถูกส่งไปด้วย',
        text: `เซิร์ฟเวอร์ตอบ 400 พร้อมกฎ ${CUSTOMER_FIELD_IS_SERVER_OWNED} — รหัสภายใน (customer_id) และเวลาที่สร้าง/แก้ไขเป็นของเซิร์ฟเวอร์ ไม่มีฟอร์มใดในหน้าจอนี้กรอกมันได้ การที่มันไปถึงเซิร์ฟเวอร์จึงเป็นบั๊ก — แจ้งผู้ดูแลระบบ`,
      };
    default:
      return null;
  }
}

/**
 * ข้อความประจำแต่ละสถานะ — แจกแจงครบโดยไม่มี `default` เพื่อให้ TypeScript เป็น
 * ผู้พิสูจน์ว่าไม่มีสถานะไหนตกหล่นเมื่อ client เพิ่มกรณีใหม่
 */
function failureCopy(
  failure: CustomerFailure,
  context: CustomerFailureContext,
): FailureCopy {
  const writing = isWriteContext(context);
  const nothingChanged = nothingChangedText(context);

  switch (failure.status) {
    case 'unauthenticated':
      return {
        heading: 'ต้องเข้าสู่ระบบก่อนจึงจะใช้หน้าจอนี้ได้',
        text: 'เซิร์ฟเวอร์ตอบ 401 — เซสชันหมดอายุหรือถูกยกเลิกไปแล้ว token ที่ถืออยู่จึงถูกล้างทิ้งและต้องเข้าสู่ระบบใหม่ (D-049)',
      };
    case 'forbidden':
      return {
        heading: 'สิทธิ์ชุดนี้ไม่ครอบคลุมคำขอนี้',
        text: `เซิร์ฟเวอร์ตอบ 403 — คำขอนี้ต้องการโมดูล ${CUSTOMER_MASTER_MODULE} ในระดับที่สูงกว่าที่แผนกของคุณถืออยู่ ข้อมูลลูกค้าเป็นข้อมูลระดับองค์กรและไม่มีขอบเขตโรงงาน (D-089) การถูกปฏิเสธจึงไม่ใช่เรื่องของโรงงานที่คุณสังกัด — ขอสิทธิ์เพิ่มที่ตารางสิทธิ์ตามแผนก${nothingChanged}`,
      };
    case 'not-found':
      /**
       * หน้ารายละเอียดเป็น URL ที่ bookmark และส่งต่อกันได้ (D-123 ข้อ 6) `404` ที่นั่น
       * จึงมักเป็น **ลิงก์เก่า** ไม่ใช่คำขอที่ชนกับคนอื่นระหว่างทำงาน — ประโยคที่บอก
       * ให้ "โหลดรายการใหม่แล้วลองอีกครั้ง" จะส่งผู้ใช้ไปกดซ้ำสิ่งที่ไม่มีอยู่
       */
      return context === 'detail'
        ? {
            heading: 'ไม่พบลูกค้ารายนี้',
            text: 'เซิร์ฟเวอร์ตอบ 404 — ลูกค้ารายที่ลิงก์นี้อ้างถึงไม่มีอยู่ในทะเบียน กด "กลับไปรายการ" เพื่อดูทะเบียนที่มีอยู่จริง',
          }
        : {
            heading: 'ไม่พบลูกค้ารายที่คำขอนี้อ้างถึง',
            text: `เซิร์ฟเวอร์ตอบ 404 — ลูกค้ารายนี้ไม่มีอยู่แล้ว (อาจถูกแก้โดยผู้ใช้อีกคนระหว่างที่หน้าจอนี้เปิดค้างอยู่) โหลดรายการใหม่แล้วลองอีกครั้ง${nothingChanged}`,
          };
    case 'conflict':
      return (
        ruleCopy(failure.error.rule) ?? {
          heading: 'มีของที่ชนกันอยู่แล้วในระบบ',
          text: `เซิร์ฟเวอร์ตอบ 409 — รหัสที่ส่งไปมีเจ้าของอยู่แล้ว ไม่ใช่ข้อผิดพลาดของระบบและการกดซ้ำจะได้คำตอบเดิม${nothingChanged}`,
        }
      );
    case 'rule-violation':
      return (
        ruleCopy(failure.error.rule) ?? {
          heading: 'คำขอนี้ติดกฎทางธุรกิจ',
          text: `เซิร์ฟเวอร์ตอบ 422 พร้อมรหัสกฎที่ชน — ไม่ใช่ข้อผิดพลาดของระบบ แต่เป็นเงื่อนไขที่ต้องแก้ก่อน${nothingChanged}`,
        }
      );
    case 'bad-request':
      return (
        ruleCopy(failure.error.rule) ?? {
          heading: 'คำขอนี้ถูกปฏิเสธว่าไม่ถูกต้อง',
          text: `เซิร์ฟเวอร์ตอบ 400 — ข้อมูลที่ส่งไปไม่ตรงรูปแบบที่ API รับ (เช่น รหัสยาวเกิน ${CUSTOMER_CODE_MAX_LENGTH} ตัวอักษร ชื่อยาวเกิน ${CUSTOMER_NAME_MAX_LENGTH} ตัวอักษร หรือสถานะที่ไม่อยู่ในสามค่าที่รับได้)${nothingChanged}`,
        }
      );
    case 'server-error':
      return {
        heading: `เซิร์ฟเวอร์ตอบ ${failure.httpStatus}`,
        text: writing
          ? 'คำขอไปถึงเซิร์ฟเวอร์แล้วแต่ทำงานไม่สำเร็จ และ **ไม่มีอะไรยืนยันว่าข้อมูลถูกเปลี่ยนหรือไม่** — โหลดรายการใหม่เพื่อดูสถานะที่เก็บอยู่จริงก่อนลองอีกครั้ง'
          : 'คำขอไปถึงเซิร์ฟเวอร์แล้วแต่ทำงานไม่สำเร็จ ยังไม่มีข้อมูลจริงมาแสดง',
      };
    case 'network-error':
      return {
        heading: 'ติดต่อเซิร์ฟเวอร์ไม่ได้',
        text: writing
          ? `${failure.detail} — ไม่มีอะไรยืนยันว่าคำขอไปถึงเซิร์ฟเวอร์หรือไม่ โหลดรายการใหม่เพื่อดูสถานะที่เก็บอยู่จริงก่อนลองอีกครั้ง`
          : `${failure.detail} — หน้าจอนี้จึงไม่มีข้อมูลจะแสดง และจะไม่เดาขึ้นมาเอง`,
      };
    case 'invalid-response':
      return {
        heading: 'ข้อมูลจากเซิร์ฟเวอร์ผิดรูปแบบ',
        text: 'หน้าจอปฏิเสธที่จะแสดงรายการลูกค้าที่อ่านได้ไม่ครบ — รายการที่ขาดไปหนึ่งรายอ่านเหมือน "ยังไม่มีลูกค้ารายนี้" ซึ่งจะพาไปสู่การสร้างรหัสที่มีเจ้าของอยู่แล้วซ้ำเข้าไป',
      };
    case 'cancelled':
      return {
        heading: 'ยกเลิกการเรียกข้อมูลแล้ว',
        text: 'คำขอถูกยกเลิกก่อนได้รับคำตอบ',
      };
  }
}

function envelopeOf(failure: CustomerFailure): ApiErrorEnvelope | null {
  return 'error' in failure ? failure.error : null;
}

interface CustomerFailureNoticeProps {
  readonly failure: CustomerFailure;
  readonly context: CustomerFailureContext;
  readonly onRetry?: () => void;
}

export function CustomerFailureNotice({
  failure,
  context,
  onRetry,
}: CustomerFailureNoticeProps) {
  const copy = failureCopy(failure, context);
  const envelope = envelopeOf(failure);
  const rule = ruleFromFailure(failure);
  const serverMessage = envelope === null ? null : envelope.message;
  // `409` และ `422` เป็นคำตอบที่ **ผู้ใช้แก้เองได้** (ใช้รหัสอื่น) ต่างจากความ
  // ล้มเหลวที่เหลือซึ่งเขาทำอะไรไม่ได้เลย — สีของป้ายจึงบอกเรื่องนั้น
  const refusedByRule = failure.status === 'rule-violation' || failure.status === 'conflict';

  return (
    <div
      className="cap-notice"
      data-testid="customer-failure"
      data-failure={failure.status}
      data-context={context}
      data-rule={rule ?? ''}
      role="status"
    >
      <StatusBadge tone={refusedByRule ? 'warning' : 'danger'}>
        {refusedByRule ? 'ติดกฎทางธุรกิจ' : 'ทำรายการไม่สำเร็จ'}
      </StatusBadge>
      <h3 className="cap-notice__title">{copy.heading}</h3>
      <p className="cap-notice__text">{copy.text}</p>

      {rule === null ? null : (
        <p className="cap-notice__text">
          กฎที่ชน:{' '}
          <code className="cap-table__code" data-testid="customer-rule">
            {rule}
          </code>
        </p>
      )}

      {serverMessage === null ? null : (
        <p className="cap-notice__note" data-testid="customer-failure-message">
          ข้อความจากเซิร์ฟเวอร์: {serverMessage}
        </p>
      )}

      {onRetry === undefined ? null : (
        <div className="cap-notice__actions">
          <button type="button" className="cap-button cap-button--ghost" onClick={onRetry}>
            ลองอีกครั้ง
          </button>
        </div>
      )}
    </div>
  );
}

/* ------------------------------------- สถานะการนำทางใน URL (D-123 ข้อ 5, 6) -- */

/**
 * ทั้งสี่พารามิเตอร์อยู่ใน query string **ไม่ใช่ใน state ของ component** เพื่อให้
 * refresh, ปุ่ม back และลิงก์ที่ส่งให้เพื่อนร่วมงานได้หน้าจอเดียวกัน (D-123 ข้อ 5)
 *
 * ค่าที่อ่านไม่ออกทุกตัว **ตกกลับเป็นค่าเริ่มต้นเงียบ ๆ ไม่ใช่หน้าจอที่พัง**: URL มา
 * จากที่ไหนก็ได้ (ลิงก์เก่า คนพิมพ์เอง สคริปต์) และตารางทะเบียนลูกค้าที่ปฏิเสธจะ
 * แสดงอะไรเลยเพราะ `?dir=sideways` ไม่ได้ช่วยใคร
 */
const VIEW_PARAM = 'view';
const DETAIL_VIEW_VALUE = 'detail';
/** เปิดหน้าแก้ไขของตัวเอง (`CustomerEditView`) — ไม่ใช่กล่องลอยทับอีกต่อไป (D-125) */
const EDIT_VIEW_VALUE = 'edit';
/** เปิดหน้าสร้างของตัวเอง (`CustomerCreateView`) — ไม่ใช่ modal อีกต่อไป (D-126) */
const CREATE_VIEW_VALUE = 'create';
const CUSTOMER_PARAM = 'customer';
const SORT_PARAM = 'sort';
const DIRECTION_PARAM = 'dir';
const PAGE_PARAM = 'page';

/**
 * 20 แถวต่อหน้า **ตายตัว** (D-123 ข้อ 2) — ไม่มีตัวเลือกให้ผู้ใช้เปลี่ยน
 *
 * ต่างจากหน้ารายการใบสั่งขายที่จำนวนแถวต่อหน้าเป็น `limit` ของ **เซิร์ฟเวอร์** จริง ๆ
 * ที่นี่ทะเบียนทั้งชุดอยู่ในเบราว์เซอร์แล้ว (`fetchAllCustomers`) การแบ่งหน้าเป็นเพียง
 * การตัดสิ่งที่ถืออยู่ให้อ่านไหว ตัวเลือกที่ไม่เปลี่ยนจำนวนคำขอเลยจึงเป็นปุ่มที่ชวน
 * ให้เข้าใจผิดว่ามันทำให้โหลดเร็วขึ้น
 */
const CUSTOMER_ROWS_PER_PAGE = 20;

/** คอลัมน์ที่เรียงได้ — 'การแก้ไข' ไม่อยู่ในนี้เพราะมันไม่ใช่ข้อมูลของลูกค้า */
const CUSTOMER_SORT_KEYS = ['code', 'name', 'status'] as const;

type CustomerSortKey = (typeof CUSTOMER_SORT_KEYS)[number];

/** ค่าเริ่มต้น = รหัสลูกค้า น้อย→มาก ซึ่งเป็นลำดับเดียวกับที่เซิร์ฟเวอร์ส่งมา */
const DEFAULT_SORT_KEY: CustomerSortKey = 'code';

const SORT_LABELS: Readonly<Record<CustomerSortKey, string>> = {
  code: 'รหัสลูกค้า',
  name: 'ชื่อลูกค้า',
  status: 'สถานะ',
};

function toSortKey(raw: string | null): CustomerSortKey {
  const keys: readonly string[] = CUSTOMER_SORT_KEYS;
  return raw !== null && keys.includes(raw) ? (raw as CustomerSortKey) : DEFAULT_SORT_KEY;
}

function toSortDirection(raw: string | null): SortDirection {
  return raw === 'desc' ? 'desc' : 'asc';
}

/**
 * เลขหน้าที่ URL ขอ — จำนวนเต็มตั้งแต่ 1 ขึ้นไปเท่านั้น
 *
 * ตรวจเป็นสตริงด้วย regex ไม่ใช่ `Number()`: `Number('')` คือ `0` และ
 * `Number(' 2 ')` คือ `2` ซึ่งทั้งคู่ทำให้ค่าที่ไม่ใช่เลขหน้ากลายเป็นเลขหน้าเงียบ ๆ
 */
function toPageNumber(raw: string | null): number {
  return raw !== null && /^\d+$/.test(raw) && Number(raw) >= 1 ? Number(raw) : 1;
}

/** ข้อความที่คอลัมน์หนึ่งถูกเรียงด้วย — สถานะเรียงตาม **ป้ายที่แสดง** (D-123 ข้อ 4) */
function sortText(customer: Customer, key: CustomerSortKey): string {
  switch (key) {
    case 'code':
      return customer.customer_code;
    case 'name':
      return customer.customer_name;
    case 'status':
      return customerStatusLabel(customer.status);
  }
}

/**
 * เรียงทั้งชุดที่ผ่านค้นหา/กรองแล้ว **ก่อน** แบ่งหน้า (D-123 ข้อ 3)
 *
 * `localeCompare(…, 'th', { numeric: true })` เป็นข้อกำหนดของ D-123 ไม่ใช่รสนิยม:
 * การเทียบด้วย `<` บน UTF-16 code unit จะวางชื่อไทยสลับกับที่พจนานุกรมวาง และจะวาง
 * `CUS-10` ไว้ก่อน `CUS-9` ซึ่งเป็นลำดับที่คนหารหัสในรายการไม่มีทางเดาถูก
 *
 * คูณด้วย `-1` สำหรับมาก→น้อย **ไม่ใช่ `reverse()`**: `reverse()` กลับลำดับของแถวที่
 * เสมอกันด้วย ทำให้ลูกค้าที่ชื่อเหมือนกันสลับที่กันทุกครั้งที่กดสลับทิศ
 */
function sortCustomers(
  items: readonly Customer[],
  key: CustomerSortKey,
  direction: SortDirection,
): readonly Customer[] {
  const factor = direction === 'desc' ? -1 : 1;
  return [...items].sort(
    (left, right) =>
      factor * sortText(left, key).localeCompare(sortText(right, key), 'th', { numeric: true }),
  );
}

/**
 * query ของหน้ารายละเอียด — **ต่อจากพารามิเตอร์ที่มีอยู่ ไม่ใช่เขียนทับทั้งเส้น**
 *
 * `sort`/`dir`/`page` จึงติดไปด้วย และปุ่ม "กลับไปรายการ" คืนผู้ใช้ไปยังหน้าและลำดับ
 * ที่เขาจากมาได้โดยไม่ต้องให้ใครจำอะไรไว้ (D-123 ข้อ 6)
 */
function detailSearch(params: URLSearchParams, customerId: string): string {
  const next = new URLSearchParams(params);
  next.set(VIEW_PARAM, DETAIL_VIEW_VALUE);
  next.set(CUSTOMER_PARAM, customerId);
  return `?${next.toString()}`;
}

/**
 * query ของหน้าแก้ไข — เหตุผลเดียวกับ `detailSearch()` ทุกที่ที่มีปุ่ม "แก้ไข" ต่อ
 * query เดิม ไม่เขียนทับ เพื่อให้ "ยกเลิก"/บันทึกสำเร็จย้อนกลับมาที่ sort/dir/page เดิมได้
 */
function editSearch(params: URLSearchParams, customerId: string): string {
  const next = new URLSearchParams(params);
  next.set(VIEW_PARAM, EDIT_VIEW_VALUE);
  next.set(CUSTOMER_PARAM, customerId);
  return `?${next.toString()}`;
}

/** query ของหน้าสร้าง — ไม่มี `customer` เพราะยังไม่มีลูกค้าให้อ้าง (D-126) */
function createSearch(params: URLSearchParams): string {
  const next = new URLSearchParams(params);
  next.set(VIEW_PARAM, CREATE_VIEW_VALUE);
  next.delete(CUSTOMER_PARAM);
  return `?${next.toString()}`;
}

/** query ของรายการ = ของเดิมลบสองคีย์ของหน้ารายละเอียด — คีย์อื่นห้ามหาย (D-123 ข้อ 5) */
function listSearch(params: URLSearchParams): string {
  const next = new URLSearchParams(params);
  next.delete(VIEW_PARAM);
  next.delete(CUSTOMER_PARAM);
  const serialized = next.toString();
  return serialized === '' ? '' : `?${serialized}`;
}

/**
 * แสดงเมื่อ `?view=edit` ถูกเปิดตรง ๆ โดยไม่มีสิทธิ์ `EDIT` — แบบเดียวกับที่
 * `ProductMasterScreen` ทำกับ `?view=edit` ของสินค้า (D-125) ด่านจริงอยู่ที่ backend
 * เสมอ นี่เป็นเพียง UX ที่ไม่เปิดฟอร์มให้กรอกงานที่จะถูกปฏิเสธตอนบันทึก
 */
function EditNotOfferedNotice() {
  return (
    <div className="cap-page">
      <div className="cap-notice" data-testid="customer-edit-unavailable" role="status">
        <StatusBadge tone="warning">ไม่ได้เปิดฟอร์มให้</StatusBadge>
        <h1 className="cap-notice__title">สิทธิ์ชุดนี้แก้ไขข้อมูลลูกค้าไม่ได้</h1>
        <p className="cap-notice__text">
          สิทธิ์ที่เซิร์ฟเวอร์ส่งมาไม่มี flag <code className="cap-table__code">can_edit</code>{' '}
          ของโมดูล <code className="cap-table__code">{CUSTOMER_MASTER_MODULE}</code> หน้าจอนี้จึง
          ไม่เปิดฟอร์มให้แก้
        </p>
        <p className="cap-notice__note">
          การไม่เปิดฟอร์มเป็นเพียง UX เพื่อไม่ให้กรอกงานที่จะถูกปฏิเสธตอนบันทึก —
          ผู้ตัดสินจริงคือ backend ทุกคำขอเสมอ
        </p>
      </div>
    </div>
  );
}

/** แสดงเมื่อ `?view=create` ถูกเปิดตรง ๆ โดยไม่มีสิทธิ์ `CREATE` (D-126) — เหตุผลเดียวกับข้างบน */
function CreateNotOfferedNotice() {
  return (
    <div className="cap-page">
      <div className="cap-notice" data-testid="customer-create-unavailable" role="status">
        <StatusBadge tone="warning">ไม่ได้เปิดฟอร์มให้</StatusBadge>
        <h1 className="cap-notice__title">สิทธิ์ชุดนี้สร้างลูกค้าไม่ได้</h1>
        <p className="cap-notice__text">
          สิทธิ์ที่เซิร์ฟเวอร์ส่งมาไม่มี flag <code className="cap-table__code">can_create</code>{' '}
          ของโมดูล <code className="cap-table__code">{CUSTOMER_MASTER_MODULE}</code> หน้าจอนี้จึง
          ไม่เปิดฟอร์มให้สร้าง
        </p>
        <p className="cap-notice__note">
          การไม่เปิดฟอร์มเป็นเพียง UX เพื่อไม่ให้กรอกงานที่จะถูกปฏิเสธตอนบันทึก —
          ผู้ตัดสินจริงคือ backend ทุกคำขอเสมอ
        </p>
      </div>
    </div>
  );
}

/* --------------------------------------------------------------- หน้าจอ -- */

export interface CustomerScreenProps {
  readonly permissions: PermissionsState;
  readonly apiBaseUrl: string;
  /** inject ได้เพื่อการทดสอบ — production ใช้ `fetch` ของเบราว์เซอร์ */
  readonly fetchImpl?: typeof fetch;
}

type CustomersState =
  | { readonly status: 'loading' }
  | { readonly status: 'ready'; readonly items: readonly Customer[] }
  | CustomerFailure;

export function CustomerScreen({
  permissions,
  apiBaseUrl,
  fetchImpl,
}: CustomerScreenProps) {
  const canCreate = can(permissions, CUSTOMER_MASTER_MODULE, 'CREATE');
  const canEdit = can(permissions, CUSTOMER_MASTER_MODULE, 'EDIT');

  const [searchParams, setSearchParams] = useSearchParams();
  const { pathname } = useLocation();
  const setTrailingCrumbs = useTrailingCrumbs();

  const [customers, setCustomers] = useState<CustomersState>({ status: 'loading' });
  const [reloadToken, setReloadToken] = useState(0);

  const [query, setQuery] = useState('');
  /** ตัวกรองสถานะ — สตริงว่างคือ "ทุกสถานะ" และเดินทางไปเป็น `?status=` ที่เซิร์ฟเวอร์ */
  const [statusFilter, setStatusFilter] = useState('');

  useEffect(() => {
    const controller = new AbortController();
    let active = true;

    // ระหว่างโหลดซ้ำหลังบันทึกสำเร็จ **ตารางเดิมยังอยู่** ไม่กระพริบเป็นหน้าว่าง:
    // ผู้ใช้เพิ่งกดปุ่มไป สิ่งที่เขาต้องเห็นคือผลของมัน ไม่ใช่หน้าจอที่หายไปทั้งจอ
    setCustomers((previous) =>
      previous.status === 'ready' ? previous : { status: 'loading' },
    );

    const options = { apiBaseUrl, fetchImpl, signal: controller.signal };
    const status = toCustomerStatusFilter(statusFilter);

    // **ทุกหน้า ไม่ใช่หน้าแรก** (D-123 ข้อ 1) — การเรียงและการแบ่งหน้าด้านล่าง
    // ทำกับทะเบียนทั้งชุด ส่วนที่หน้าไหนล้มเหลวก็ล้มทั้งก้อน (ดู `fetchAllCustomers`)
    void fetchAllCustomers(status === undefined ? {} : { status }, options).then((result) => {
      if (!active || result.status === 'cancelled') {
        return;
      }
      setCustomers(
        result.status === 'ready' ? { status: 'ready', items: result.items } : result,
      );
    });

    return () => {
      active = false;
      controller.abort();
    };
  }, [apiBaseUrl, fetchImpl, reloadToken, statusFilter]);

  /* --------------------------------- เรียง/แบ่งหน้า/รายละเอียด จาก URL ----- */

  const viewParam = searchParams.get(VIEW_PARAM);
  const detailCustomerId =
    viewParam === DETAIL_VIEW_VALUE ? (searchParams.get(CUSTOMER_PARAM)?.trim() ?? '') : '';
  const showDetail = detailCustomerId !== '';

  const editCustomerId =
    viewParam === EDIT_VIEW_VALUE ? (searchParams.get(CUSTOMER_PARAM)?.trim() ?? '') : '';
  const showEdit = editCustomerId !== '';

  const showCreate = viewParam === CREATE_VIEW_VALUE;

  const sortKey = toSortKey(searchParams.get(SORT_PARAM));
  const sortDirection = toSortDirection(searchParams.get(DIRECTION_PARAM));
  const requestedPage = toPageNumber(searchParams.get(PAGE_PARAM));

  // หน้าจอย่อยของหน้านี้เป็น search param ไม่ใช่ nested route จึงต้องบอก
  // `DesktopShell` เองว่าผู้ใช้อยู่ลึกแค่ไหน (แบบเดียวกับ `ProductMasterScreen`)
  useEffect(() => {
    setTrailingCrumbs(
      showCreate
        ? [{ label: 'เพิ่มลูกค้าใหม่' }]
        : showEdit
          ? [{ label: 'แก้ไขข้อมูลลูกค้า' }]
          : showDetail
            ? [{ label: 'รายละเอียดลูกค้า' }]
            : [],
    );
  }, [showCreate, showDetail, showEdit, setTrailingCrumbs]);

  /**
   * แก้เฉพาะคีย์ที่ระบุ — คีย์อื่นใน URL ถูกคัดลอกต่อไปทั้งหมด (D-123 ข้อ 5)
   *
   * `replace` สำหรับการเปลี่ยนที่ผู้ใช้ไม่ได้ "นำทาง" (เช่นรีเซ็ตหน้ากลับหน้าแรก
   * ตอนพิมพ์คำค้น) ไม่งั้นการพิมพ์หนึ่งคำจะกองประวัติไว้หนึ่งรายการต่อตัวอักษร
   * และปุ่ม back จะย้อนกลับไปทีละตัวอักษร
   */
  const updateSearch = (
    changes: Readonly<Record<string, string | null>>,
    replace = false,
  ) => {
    const next = new URLSearchParams(searchParams);
    for (const [key, value] of Object.entries(changes)) {
      if (value === null) {
        next.delete(key);
      } else {
        next.set(key, value);
      }
    }
    setSearchParams(next, { replace });
  };

  /** กลับหน้าแรก — ใช้ร่วมกันโดยค้นหา กรองสถานะ และการเปลี่ยน sort (D-123 ข้อ 2) */
  const resetToFirstPage = () => {
    updateSearch({ [PAGE_PARAM]: null }, true);
  };

  const handleSort = (columnKey: string, direction: SortDirection) => {
    updateSearch({
      [SORT_PARAM]: columnKey,
      [DIRECTION_PARAM]: direction,
      // ลำดับใหม่ทำให้ "หน้าที่ 3" หมายถึงคนละกลุ่มแถว การค้างอยู่หน้าเดิมจึงเท่ากับ
      // พาผู้ใช้ไปอยู่กลางรายการที่เขาไม่ได้ขอ
      [PAGE_PARAM]: null,
    });
  };

  const goToPage = (page: number) => {
    updateSearch({ [PAGE_PARAM]: String(page) });
  };

  const customerItems = customers.status === 'ready' ? customers.items : [];
  const matchedItems = filterCustomers(customerItems, query);
  const orderedItems = sortCustomers(matchedItems, sortKey, sortDirection);

  /* ---------------------------------------- แถบหน้า (D-123 ข้อ 2) --------- */

  const totalRows = orderedItems.length;
  const pageCount = Math.max(1, Math.ceil(totalRows / CUSTOMER_ROWS_PER_PAGE));
  /**
   * หน้าที่เกินจำนวนหน้าจริง → **หน้าสุดท้าย ไม่ใช่ตารางว่าง** (D-123 ข้อ 2)
   *
   * เกิดได้จริงจาก URL ที่ยังถือ `page=5` ไว้หลังผู้ใช้ลบตัวกรองหรือพิมพ์คำค้น
   * — ตารางว่างที่มีปุ่ม "ก่อนหน้า" กดได้อ่านเหมือนข้อมูลหายไป
   */
  const currentPage = Math.min(requestedPage, pageCount);
  const firstRowIndex = (currentPage - 1) * CUSTOMER_ROWS_PER_PAGE;
  const pageItems = orderedItems.slice(firstRowIndex, firstRowIndex + CUSTOMER_ROWS_PER_PAGE);
  const rowRangeLabel =
    totalRows === 0
      ? ''
      : `แถว ${firstRowIndex + 1}–${firstRowIndex + pageItems.length} จาก ${totalRows}`;

  /* --------------------------- หน้าสร้าง/หน้าแก้ไข/หน้ารายละเอียด (D-123, D-125, D-126) --- */

  if (showCreate) {
    // ด่านจริงอยู่ที่ backend เสมอ — เช็คนี้แค่ไม่เปิดฟอร์มที่จะถูกปฏิเสธตอนบันทึก
    if (!canCreate) {
      return <CreateNotOfferedNotice />;
    }
    return (
      <CustomerCreateView
        cancelSearch={listSearch(searchParams)}
        detailSearchFor={(customerId) => detailSearch(searchParams, customerId)}
        apiBaseUrl={apiBaseUrl}
        fetchImpl={fetchImpl}
        onCreated={() => {
          setReloadToken((token) => token + 1);
        }}
      />
    );
  }

  if (showEdit) {
    // ด่านจริงอยู่ที่ backend เสมอ — เช็คนี้แค่ไม่เปิดฟอร์มที่จะถูกปฏิเสธตอนบันทึก
    if (!canEdit) {
      return <EditNotOfferedNotice />;
    }
    return (
      <CustomerEditView
        customerId={editCustomerId}
        detailSearch={detailSearch(searchParams, editCustomerId)}
        apiBaseUrl={apiBaseUrl}
        fetchImpl={fetchImpl}
        onSaved={() => {
          setReloadToken((token) => token + 1);
        }}
      />
    );
  }

  if (showDetail) {
    return (
      <CustomerDetailView
        customerId={detailCustomerId}
        canEdit={canEdit}
        backSearch={listSearch(searchParams)}
        editSearch={editSearch(searchParams, detailCustomerId)}
        reloadToken={reloadToken}
        apiBaseUrl={apiBaseUrl}
        fetchImpl={fetchImpl}
      />
    );
  }

  return (
    <div className="cap-page" data-testid="customer-master">
      <div className="cap-page__head">
        <div>
          <h1 className="cap-page__title">
            ลูกค้า (Customer Master)
            <InfoHint
              label="เกี่ยวกับทะเบียนลูกค้า"
              text={
                <>
                  ทะเบียนลูกค้าของทั้งองค์กร — <strong>ไม่แยกตามโรงงาน</strong> (D-089)
                  ใบสั่งขาย การวางแผนความต้องการ และการส่งของอ้างถึงลูกค้าจากที่นี่
                </>
              }
            />
          </h1>
        </div>
      </div>

      {!canCreate && !canEdit ? (
        <div className="cap-notice" data-testid="customer-read-only" role="status">
          <StatusBadge tone="warning">ดูได้อย่างเดียว</StatusBadge>
          <h2 className="cap-notice__title">สิทธิ์ชุดนี้ยังแก้ทะเบียนลูกค้าไม่ได้</h2>
          <p className="cap-notice__text">
            สิทธิ์ที่เซิร์ฟเวอร์ส่งมาไม่มี flag{' '}
            <code className="cap-table__code">can_create</code> หรือ{' '}
            <code className="cap-table__code">can_edit</code> ของโมดูล{' '}
            <code className="cap-table__code">{CUSTOMER_MASTER_MODULE}</code> ปุ่ม
            &quot;เพิ่มลูกค้า&quot; และ &quot;แก้ไข&quot; จึงไม่แสดง — รายการ ช่องค้นหา
            และตัวกรองสถานะยังใช้ได้ตามปกติ
          </p>
          <p className="cap-notice__note">
            การซ่อนปุ่มเป็นเพียง UX เพื่อไม่ให้กดสิ่งที่จะถูกปฏิเสธ — ผู้ตัดสินจริงคือ
            backend ทุกคำขอเสมอ
          </p>
        </div>
      ) : null}

      {/* ------------------------------------- ค้นหา + กรองสถานะ + ปุ่มสร้าง -- */}

      <div className="cap-filters" data-testid="customer-toolbar">
        <label className="cap-field">
          <span className="cap-field__label">
            ค้นหาลูกค้า
            <InfoHint
              label="เกี่ยวกับช่องค้นหาลูกค้า"
              text="กรองรายการด้านล่างจากรหัสหรือชื่อลูกค้า — กรองจากรายการที่โหลดมาแล้ว ไม่ได้ถามเซิร์ฟเวอร์ใหม่ ช่องว่างหมายถึงแสดงทุกราย"
            />
          </span>
          <input
            className="cap-input"
            type="search"
            name="customer_query"
            data-testid="customer-search"
            value={query}
            autoComplete="off"
            onChange={(event) => {
              setQuery(event.target.value);
              // คำค้นใหม่ = ชุดแถวใหม่ "หน้าที่ 2" ของชุดเดิมไม่มีความหมายกับชุดนี้
              resetToFirstPage();
            }}
          />
        </label>

        <label className="cap-field">
          <span className="cap-field__label">
            สถานะ
            <InfoHint
              label="เกี่ยวกับตัวกรองสถานะ"
              text={
                <>
                  ต่างจากช่องค้นหา — ตัวกรองนี้ <strong>ถามเซิร์ฟเวอร์ใหม่</strong> ด้วย{' '}
                  <code className="cap-table__code">?status=</code> จึงครอบคลุมลูกค้าทุกราย
                  ไม่ใช่เฉพาะหน้าที่โหลดมาแล้ว
                </>
              }
            />
          </span>
          <select
            className="cap-input"
            name="status_filter"
            data-testid="customer-status-filter"
            value={statusFilter}
            onChange={(event) => {
              setStatusFilter(event.target.value);
              resetToFirstPage();
            }}
          >
            <option value="">ทุกสถานะ</option>
            {CUSTOMER_STATUS_DESCRIPTORS.map((descriptor) => (
              <option key={descriptor.code} value={descriptor.code}>
                {descriptor.label}
              </option>
            ))}
          </select>
        </label>

        {canCreate ? (
          <Link
            className="cap-button cap-button--primary"
            data-testid="customer-create-open"
            to={{ pathname, search: createSearch(searchParams) }}
          >
            เพิ่มลูกค้า
          </Link>
        ) : null}
      </div>

      {/* ------------------------------------------------------- รายการลูกค้า -- */}

      {customers.status === 'loading' ? (
        <div className="cap-notice" data-testid="customer-loading" role="status">
          <p className="cap-notice__text">กำลังโหลดรายการลูกค้า…</p>
        </div>
      ) : null}

      {customers.status !== 'loading' && customers.status !== 'ready' ? (
        <CustomerFailureNotice
          failure={customers}
          context="customers"
          onRetry={() => {
            setReloadToken((token) => token + 1);
          }}
        />
      ) : null}

      {customers.status === 'ready' && customerItems.length === 0 ? (
        <div className="cap-notice" data-testid="customer-empty" role="status">
          <StatusBadge tone="neutral">ยังไม่มีลูกค้า</StatusBadge>
          <h2 className="cap-notice__title">
            {statusFilter === ''
              ? 'ยังไม่มีลูกค้าในระบบเลย'
              : `ไม่มีลูกค้าที่สถานะเป็น ${customerStatusLabel(statusFilter)}`}
          </h2>
          <p className="cap-notice__text">
            เซิร์ฟเวอร์ตอบสำเร็จแต่รายการว่างเปล่า — ไม่ใช่การโหลดที่ล้มเหลว
            {statusFilter === '' ? '' : ' เลือก "ทุกสถานะ" เพื่อดูลูกค้าทั้งหมด'}
          </p>
        </div>
      ) : null}

      {/**
       * "หาไม่เจอ" ไม่ใช่ "ยังไม่มีลูกค้า" และไม่ใช่ "โหลดไม่สำเร็จ"
       *
       * ทั้งสามอย่างให้หน้าจอที่ไม่มีตารางเหมือนกัน แต่สิ่งที่ผู้ใช้ต้องทำต่อคนละเรื่อง
       * กันโดยสิ้นเชิง — อันนี้แก้ด้วยการลบคำค้น ไม่ใช่การเพิ่มลูกค้าหรือโทรหาไอที
       */}
      {customers.status === 'ready' &&
      customerItems.length > 0 &&
      matchedItems.length === 0 ? (
        <div className="cap-notice" data-testid="customer-no-match" role="status">
          <StatusBadge tone="neutral">ไม่พบลูกค้าที่ค้นหา</StatusBadge>
          <h2 className="cap-notice__title">
            ไม่มีลูกค้าที่ตรงกับ &quot;{query.trim()}&quot;
          </h2>
          <p className="cap-notice__text">
            รายการนี้มีลูกค้า {customerItems.length} ราย แต่ไม่มีรายใดที่รหัสหรือชื่อมีคำนี้
            อยู่ — ล้างคำค้นเพื่อดูทั้งหมด
          </p>
        </div>
      ) : null}

      {customers.status === 'ready' && matchedItems.length > 0 ? (
        <section className="cap-card cap-card--table" aria-label="ลูกค้าทั้งหมด">
          <div className="cap-card__head">
            <h2 className="cap-card__title">ลูกค้าทั้งหมด</h2>
            <span className="cap-card__hint">
              {query.trim() === ''
                ? `${SORT_LABELS[sortKey]} ${sortDirection === 'asc' ? 'น้อย→มาก' : 'มาก→น้อย'}`
                : `แสดง ${matchedItems.length} จาก ${customerItems.length} รายที่ตรงกับคำค้น`}
              <InfoHint
                label="การเรียงและการแบ่งหน้าทำงานอย่างไร"
                text={`กดหัวคอลัมน์เพื่อเรียง กดซ้ำเพื่อสลับทิศ — เรียงทั้งทะเบียนที่โหลดมาครบทุกหน้าแล้ว ไม่ใช่เฉพาะ ${CUSTOMER_ROWS_PER_PAGE} แถวที่เห็น จากนั้นจึงแบ่งหน้าละ ${CUSTOMER_ROWS_PER_PAGE} แถว ลำดับและเลขหน้าติดอยู่ใน URL จึงส่งลิงก์ให้คนอื่นเห็นหน้าเดียวกันได้`}
              />
            </span>
          </div>
          <div className="cap-table-wrap">
            <table className="cap-table" data-testid="customer-table">
              <caption className="cap-visually-hidden">
                ลูกค้าทั้งหมดขององค์กร พร้อมรหัสที่ใบสั่งขายและการส่งของอ้างถึง
              </caption>
              <thead>
                <tr>
                  {CUSTOMER_SORT_KEYS.map((key) => (
                    <SortableHeader
                      key={key}
                      columnKey={key}
                      label={SORT_LABELS[key]}
                      activeKey={sortKey}
                      direction={sortDirection}
                      onSort={handleSort}
                      testId={`customer-sort-${key}`}
                    />
                  ))}
                  {/* 'การแก้ไข' ไม่ใช่ข้อมูลของลูกค้า จึงเรียงด้วยไม่ได้ (D-123 ข้อ 3) */}
                  {canEdit ? <th scope="col">การแก้ไข</th> : null}
                </tr>
              </thead>
              <tbody>
                {pageItems.map((customer) => (
                  <tr
                    key={customer.customer_id}
                    data-testid={`customer-row-${customer.customer_code}`}
                  >
                    {/**
                     * ทั้งรหัสและชื่อเป็น **ลิงก์จริง** ไม่ใช่ `<tr onClick>` (D-123 ข้อ 6)
                     * — แถวที่เปิดได้ด้วยเมาส์อย่างเดียวคือหน้ารายละเอียดที่ไม่มีอยู่
                     * สำหรับคนที่ใช้คีย์บอร์ด และลิงก์จริงยังเปิดแท็บใหม่ได้ด้วย
                     */}
                    <th scope="row" className="cap-table__row-head">
                      <Link
                        className="cap-table__link"
                        data-testid={`customer-detail-open-${customer.customer_code}`}
                        to={{
                          pathname,
                          search: detailSearch(searchParams, customer.customer_id),
                        }}
                      >
                        {customer.customer_code}
                      </Link>
                    </th>
                    <td>
                      <Link
                        to={{
                          pathname,
                          search: detailSearch(searchParams, customer.customer_id),
                        }}
                      >
                        {customer.customer_name}
                      </Link>
                    </td>
                    <td>
                      <StatusBadge tone={customerStatusTone(customer.status)}>
                        {customerStatusLabel(customer.status)}
                      </StatusBadge>
                    </td>
                    {canEdit ? (
                      <td>
                        <Link
                          className="cap-button cap-button--ghost"
                          data-testid={`customer-edit-open-${customer.customer_code}`}
                          to={{
                            pathname,
                            search: editSearch(searchParams, customer.customer_id),
                          }}
                        >
                          แก้ไข
                        </Link>
                      </td>
                    ) : null}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          {/*
            D-123 ข้อ 2 — ก่อนหน้า/ถัดไป + "แถว x–y จาก N" รูปแบบเดียวกับหน้ารายการ
            ใบสั่งขาย ต่างกันที่ปุ่ม "ถัดไป" ปิดเมื่อ **ถึงหน้าสุดท้ายจริง** ไม่ใช่เมื่อ
            เซิร์ฟเวอร์เลิกส่ง cursor: ที่นี่จำนวนแถวทั้งหมดอยู่ในมือแล้ว จำนวนหน้าจึง
            เป็นสิ่งที่รู้ได้ ไม่ใช่สิ่งที่ต้องเดา
          */}
          <div className="cap-card__foot cap-pager" data-testid="customer-pager">
            <span className="cap-pager__count" data-testid="customer-pager-range">
              {rowRangeLabel}
            </span>
            <button
              type="button"
              className="cap-button cap-button--ghost"
              data-testid="customer-page-prev"
              disabled={currentPage <= 1}
              onClick={() => {
                goToPage(currentPage - 1);
              }}
            >
              ก่อนหน้า
            </button>
            <button
              type="button"
              className="cap-button cap-button--ghost"
              data-testid="customer-page-next"
              disabled={currentPage >= pageCount}
              onClick={() => {
                goToPage(currentPage + 1);
              }}
            >
              ถัดไป
            </button>
            <span className="cap-pager__count" data-testid="customer-page-count">
              หน้า {currentPage} จาก {pageCount}
            </span>
          </div>
        </section>
      ) : null}
    </div>
  );
}
